import assetPath from '/app/packages/lebenslauf/articles/src/assets/individueller-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')